import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import history from '../../../../../shared/history';
import { Translate } from '../../../../../shared/LanguageService';
import { getSiteName } from '../../../../../shared/Site';
import * as Site from '../../../../../shared/Site';
import { useFeatureFlagVariant } from '../../../../../shared/featureFlags/useFeatureFlagVariant';
import { FeatureFlagVariantKeys } from '../../../../../shared/featureFlags/featureFlagVariantKeys';
import LogoSE360 from '../../../../../assets/images/se360_logo_white_long.svg';
import LogoZentuvo from '../../../../../assets/images/zentuvowhite.svg';
import ChristmasIcon from '../../../../../assets/images/seasonal/LoggaSE360Jul.svg';
import EasterIcon from '../../../../../assets/images/seasonal/LogoSE360Easter.svg';
import HalloweenIcon from '../../../../../assets/images/seasonal/LoggaSE360Pumpa.svg';

type SeasonalIcon = {
    src: string;
    alt: string;
};

const seasonalIcons: Record<string, SeasonalIcon> = {
    christmas: { src: ChristmasIcon, alt: "Santa's hat" },
    easter: { src: EasterIcon, alt: 'Easter egg' },
    halloween: { src: HalloweenIcon, alt: 'Pumpkin' }
};

function useSeasonalIcon(): SeasonalIcon | null {
    let season = useFeatureFlagVariant(FeatureFlagVariantKeys.SeasonalLogo, null);

    if (season === null || !Object.prototype.hasOwnProperty.call(seasonalIcons, season)) {
        return null;
    }
    return seasonalIcons[season];
}

type SE360LogoProps = {
    productName: string;
    site: string;
};

function SE360Logo({ productName, site }: SE360LogoProps) {
    let seasonalIcon = useSeasonalIcon();
    let Logo;
    {
        site === getSiteName(Site.Zentuvo)
            ? (Logo = LogoZentuvo)
            : (Logo = LogoSE360)
    }
    return (
        <Box
            sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            }}
            onClick={() => {
                history.push('/');
            }}
        >
            <img height="16" src={Logo} alt="logo" />
            {seasonalIcon ? (
                <img height="16" src={seasonalIcon.src} alt={seasonalIcon.alt} />
            ) : null}
            <Typography
                m={1}
                sx={{
                    fontFamily: 'Gilroy-Regular',
                    fontSize: '16px',
                    margin: 0
                }}
            >
                |
            </Typography>
            <Typography
                variant="h6"
                component="div"
                sx={{
                    fontFamily: 'Gilroy-Regular',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '28.8px',
                    letterSpacing: '0.15px'
                }}
            >
                {productName}
            </Typography>
        </Box>
    );
}

function TranslatedSE360Logo({ site }) {
    let productName = Translate('header/nav/product-name');

    return <SE360Logo productName={productName} site={site} />;
}

export default TranslatedSE360Logo;
